import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { createApp } from '../store/actions/appAction';
import UploadImage from "../components/uploadImage";
import Header from '../components/Header'
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Menubar from '../components/Menubar';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles((theme) => ({
    appBar: {
      position: 'relative',
    },
    layoutMainCreateApp: {
      background: "white",
      padding: "2rem 2rem",
      borderRadius: "10px",
      [theme.breakpoints.up("sm")]: {
        width: "80%",
        marginLeft: 'auto',
        marginRight: 'auto',
      },
    },
    stepper: {
      padding: theme.spacing(3, 0, 5),
    },
    buttons: {
      display: 'flex',
      justifyContent: 'flex-end',
    },
    button: {
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(3),
      marginLeft: theme.spacing(1),
    },
    contentCreateApp : {
      paddingTop: "3%",
      paddingLeft: "15%",
      backgroundColor: "#e8e8e8",
      paddingRight: "5%",
      paddingBottom: "14%",

      [theme.breakpoints.down("sm")]: {
        paddingTop: "30%",
        paddingLeft: "0",
        paddingRight: "0"
      },
    },
}));



const CreateApp = () => {
    useEffect(() => {
      window.scrollTo(0, 0)
    }, [])
    const classes = useStyles();
    const dispatch = useDispatch()
    const history = useHistory()
    const [ input, setInput ] = useState({
        appName: '',
        description: '',
        redirectUrlApp: '',
        image: ''
    })

    const handleImageData = (imageFile) => {
      setInput({ ...input, image: imageFile })
    }

    const handleSubmit = (e) => {
      e.preventDefault()
      const { appName, description, redirectUrlApp, image } = input
      const formData = new FormData()
      if (image) {
        formData.append('image', image)      
      }  
      formData.append('appName', appName)
      formData.append('description', description)
      formData.append('redirectUrlApp', redirectUrlApp)

      dispatch(createApp(formData))
      history.push('/app')
      
    }

    const handleChange = (e) => {
        let { name, value } = e.target
        setInput({ ...input, [name]: value })
    }

    const handleHome = () => {
      history.push('/app')
    }
        
    return (
        <React.Fragment>
        <Header page='CreateApp'/>
        <CssBaseline />
        <Menubar/>
        <Grid item xs={12} md={12} className={classes.contentCreateApp}>
        <main className={classes.layoutMainCreateApp}>
            <React.Fragment>
            <form className={classes.form} onSubmit={handleSubmit}>
            <Grid container spacing={3} style={{justifyContent: "center"}}>
                <Grid item xs={12}>
                  <p className="font-size-16 reguler text-darkgrey mb-5">Broadcast Message</p>
                  <p className="font-size-12 reguler text-darkgrey mb-5">Send to one/many number</p>
                </Grid>
                <Grid item xs={12} className='d-flex justify-content-space-between' style={{flexDirection:'row'}}>
                  <div xs={10} md={4} style={{border: "3px dashed #dadada"}}>                    
                  </div>
                  <div xs={10} md={4} style={{border: "3px dashed #dadada"}}>
                    <UploadImage imageData={handleImageData}/>
                  </div>
                </Grid>
                <Grid item xs={12}>  
                <p className="font-size-16 reguler text-darkgrey mb-5">Text/Caption</p>
                <TextField
                  id="outlined-multiline-static"
                  variant="outlined"
                  margin="none"
                  size="small"
                  placeholder="Masukkan isi pesan anda"
                  defaultValue=""
                  required
                  fullWidth
                  multiline
                  rows={4}
                  name="redirectUrlApp"
                  onChange={handleChange}
                />
                </Grid>
            </Grid>
            <Grid xs={12} md={12} className="mt-15 d-flex" style={{justifyContent: "flex-end"}}>
              <Button
                className="btn-white mx-4 text-transform-unset"
                spacing={5}
                onClick={handleHome}
                style={{padding: "5px 40px"}}
              >
                Batal
              </Button>
              <Button
                type="submit"
                className="btn-black text-transform-unset"
                spacing={5}
                onClick={handleSubmit}
                style={{padding: "5px 40px"}}
              >
                Send
              </Button>
            </Grid>
            </form>
            </React.Fragment> 
          </main>
        </Grid>
      </React.Fragment>     
    )
}

export default CreateApp
